import type { FC } from 'react';

import { DATE_WITH_TIMEZONE_FORMAT } from '@iconik-io/core/src/date/date_formats';

import type { CalendarDropdownOption } from '../calendar/default_options';
import InputDate, { type InputDateProps } from '../input_date/input_date';

type Props = Omit<InputDateProps, 'optionsDropdown' | 'optionsPresets'>;

const initialOptionsDropdown: CalendarDropdownOption[] = [];
const initialOptionsPresets: CalendarDropdownOption[] = [];

const InputDateTime: FC<Props> = ({ isRangeMode = false, ...props }) => (
  <InputDate
    {...props}
    isRangeMode={isRangeMode}
    optionsDropdown={initialOptionsDropdown}
    optionsPresets={initialOptionsPresets}
    outputFormat={DATE_WITH_TIMEZONE_FORMAT}
    withTimePicker
  />
);

export default InputDateTime;
